import React, { useState } from "react";
import { Container } from 'react-bootstrap';
import Image from './image';
import "./style.scss";

function Details(props) {
    return (
        <Container className={`details slide-in-right`}>
            {!Utils.isMobile() && <div className="title tabindex" tabIndex="0">
                {props.title}
            </div>}
            <div className="name tabindex" tabIndex="0">
                {props.student.first_name}
            </div>
            <div className="name">
                { props.student.last_name &&
                    <div className="tabindex" tabIndex="0">{props.student.last_name}</div>
                }
            </div>
            <div className="story">
                { props.student.story &&
                    <div className="tabindex" tabIndex="0">{props.student.story}</div>
                }
            </div>
            {!Utils.isMobile() && props?.enable_meet_more_button !=0 && <a className="more-students tabindex" href={props.view_all.url}>{props.view_all.title}</a> }
        </Container>
    )
}

export const Student = (props) => {
    const [clicked, setclicked] = useState(null);
    return (
        <Container className="student">
            <Details {...props} i={null} clicked={clicked} />
            <Image {...props} setClicked={setclicked} clicked={clicked} />
            {Utils.isMobile() && <a className="more-students-mb" href={props.view_all.url}>{props.view_all.title}</a>}
        </Container>
    );
};

export default Student;
